import { createContext, useContext } from 'react';

import { readSavedAccessToken, readSavedRefreshToken } from 'src/common/utils';

export const AccessTokenContext = createContext({
    get accessToken() {
        return readSavedAccessToken();
    },
    // eslint-disable-next-line
    setAccessToken: (newToken: string | null) => {},
});

export const RefreshTokenContext = createContext({
    get refreshToken() {
        return readSavedRefreshToken();
    },
    // eslint-disable-next-line
    setRefreshToken: (newToken: string | null) => {},
});

export const useAccessToken = () => {
    const { accessToken } = useContext(AccessTokenContext);
    return accessToken || undefined;
};